import { observer } from 'mobx-react';

// Skeleton dimensions match the approximate size of the filter dropdowns:
// - Course Type: widest dropdown (w-36 = 9rem)
// - License: medium width (w-28 = 7rem)
// - Delivery Channel: narrowest (w-24 = 6rem)
// Height matches the standard input height (h-9 = 2.25rem)
function Skeleton() {
  return (
    <>
      <div className="mr-3">
        <div className="h-9 w-36 bg-muted rounded animate-pulse"></div>
      </div>
      <div className="mr-3">
        <div className="h-9 w-28 bg-muted rounded animate-pulse"></div>
      </div>
      <div className="mr-3">
        <div className="h-9 w-24 bg-muted rounded animate-pulse"></div>
      </div>
    </>
  );
}

export default observer(Skeleton);
